import { render, staticRenderFns } from "./Tournament2022.vue?vue&type=template&id=780fd3ea&scoped=true"
import script from "./Tournament2022.vue?vue&type=script&lang=js"
export * from "./Tournament2022.vue?vue&type=script&lang=js"
import style0 from "./Tournament2022.vue?vue&type=style&index=0&id=780fd3ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780fd3ea",
  null
  
)

export default component.exports